// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from '/data/app/jenkins/data/workspace/FESingleCommon/node_modules/.pnpm/@umijs+runtime@3.5.40_react@17.0.2/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';
import LoadingComponent from '@/pages/components/loading';

export function getRoutes() {
  const routes = [
  {
    "path": "/modify",
    "routes": [
      {
        "path": "/modify/modifyPhoneForErp",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__modifyPhoneForErp' */'@/pages/modifyPhoneForErp'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/modify/modifyCompanyNameForErp",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__modifyCompanyNameForErp' */'@/pages/modifyCompanyNameForErp'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/data/app/jenkins/data/workspace/FESingleCommon/src/pages/404'), loading: LoadingComponent}),
        "exact": true
      }
    ]
  },
  {
    "path": "/service",
    "routes": [
      {
        "path": "/service/details",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__details' */'@/pages/details'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/service/payment",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__payment' */'@/pages/payment'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/service/combineDetails",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__combineDetails' */'@/pages/combineDetails'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/data/app/jenkins/data/workspace/FESingleCommon/src/pages/404'), loading: LoadingComponent}),
        "exact": true
      }
    ]
  },
  {
    "path": "/rpa",
    "routes": [
      {
        "path": "/rpa/all",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__rpa' */'@/pages/rpa'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/rpa/addMachine",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__rpa__myScripts__addMachine' */'@/pages/rpa/myScripts/addMachine'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/data/app/jenkins/data/workspace/FESingleCommon/src/pages/404'), loading: LoadingComponent}),
        "exact": true
      }
    ]
  },
  {
    "path": "/",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'layout' */'@/layout'), loading: LoadingComponent}),
    "routes": [
      {
        "path": "/*",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__index' */'@/pages/index'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/data/app/jenkins/data/workspace/FESingleCommon/src/pages/404'), loading: LoadingComponent}),
        "exact": true
      }
    ]
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
